import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
import { computed } from "vue";

const API_URL = axiosUrl.getAxiosUrl();
const env = computed(() => store.state.auth.env);

class MailingService {
  async sendTestMailing(receivers, subject, mailText) {
    return await axios
      .post(API_URL + "/salesforce/PostStartInvestmentNewsletter", {
        receivers: receivers,
        subject: subject,
        mailText: mailText,
        draft: true,
      })
      .then(() => {
        // add some success here
        store.commit(
          "grantItems/updateModalError",
          "The mail test sending has started."
        ),
          store.commit("grantItems/enableModalError");
      })
      .catch((error) => {
        store.commit("grantItems/updateModalError", error.response.data),
          store.commit("grantItems/enableModalError");
      });
  }

  async sendMailing(receivers, subject, mailText) {
    return await axios
      .post(API_URL + "/salesforce/PostStartInvestmentNewsletter", {
        receivers: receivers,
        subject: subject,
        mailText: mailText,
        draft: false,
      })
      .then(() => {
        // add some success here
        store.commit(
          "grantItems/updateModalError",
          "The mail sending has started."
        ),
          store.commit("grantItems/enableModalError");
      })
      .catch((error) => {
        store.commit("grantItems/updateModalError", error.response.data),
          store.commit("grantItems/enableModalError");
      });
  }

  async shareNews(name, organisation, address, id) {
    if (organisation == null || organisation == "") {
      store.commit("grantItems/updateModalError", "E-mail is verplicht!"),
        store.commit("grantItems/enableModalError");
    }
    if (address == null || address == "") {
      store.commit("grantItems/updateModalError", "E-mail is verplicht!"),
        store.commit("grantItems/enableModalError");
    }
    if (name == null || name == "") {
      store.commit("grantItems/updateModalError", "Naam is verplicht!"),
        store.commit("grantItems/enableModalError");
    }

    return await axios
      .post(API_URL + "/mailing/shareNews", {
        receiverName: name,
        receiverOrganisationName: organisation,
        receiverEmail: address,
        newsId: id,
      })
      .then(() => {
        store.commit("news/disableShareNews");
      });
  }

  async shareNewsMultiple(recipients, id) {
    const noNull = recipients.filter((doc) => {
      return Object.values(doc).every((prop) => prop !== null);
    });
    if (noNull.length != recipients.length) {
      store.commit(
        "grantItems/updateModalError",
        "Naam, Organisatie, E-mail is verplicht!"
      ),
        store.commit("grantItems/enableModalError");
    }
    return await axios
      .post(API_URL + "/mailing/shareNewsMultiple", {
        recipients: recipients,
        newsId: id,
      })
      .then(() => {
        store.commit("news/disableShareNews");
      })
      .catch((error) => {
        store.commit("news/disableShareNews");
        store.commit("grantItems/updateModalError", error.response.data),
          store.commit("grantItems/enableModalError");
      });
  }

  async shareScheme(email, message, name, organisation, id, locale) {
    if (env.value === 0) {
      if (message == null || message == "") {
        store.commit(
          "grantItems/updateModalError",
          "Het bericht is verplicht!"
        ),
          store.commit("grantItems/enableModalError");
      }
    }
    if (email == null || email == "") {
      store.commit("grantItems/updateModalError", "E-mail is verplicht!"),
        store.commit("grantItems/enableModalError");
    }

    return await axios
      .post(
        API_URL + "/mailing/shareScheme",
        {
          receiverName: name,
          receiverOrganisationName: organisation,
          receiverEmail: email,
          message: message,
          schemeIds: [id],
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .then(() => {
        store.commit("grantItems/disableShareGrantItem");
      });
  }

  async shareSchemeMultiple(recipients, message, id, reportType) {
    if (env.value === 0) {
      if (message == null || message == "") {
        store.commit(
          "grantItems/updateModalError",
          "Het bericht is verplicht!"
        ),
          store.commit("grantItems/enableModalError");
      }
    }
    return await axios
      .post(API_URL + "/mailing/shareSchemesMultiple", {
        recipients: recipients,
        message: message,
        reportType: reportType,
        schemeIds: [id],
      })
      .then(() => {
        store.commit("grantItems/disableShareGrantItem");
      })
      .catch((error) => {
        store.commit("grantItems/disableShareGrantItem");
        store.commit("grantItems/updateModalError", error.response.data),
          store.commit("grantItems/enableModalError");
      });
  }

  async shareSchemes(
    address,
    message,
    description,
    reportTitle,
    customerName,
    customerAccountName,
    ids,
    locale
  ) {
    if (message == null || message == "") {
      store.commit(
        "grantItems/updateModalError",
        "The message cannot be empty!"
      ),
        store.commit("grantItems/enableModalError");
    }
    if (address == null || address == "") {
      store.commit("grantItems/updateModalError", "Email cannot be empty!"),
        store.commit("grantItems/enableModalError");
    }
    return await axios
      .post(
        API_URL + "/mailing/shareScheme",
        {
          receiverName: customerAccountName,
          receiverOrganisationName: customerName,
          receiverEmail: address,
          message: message,
          schemeIds: ids,
          reportTitle: reportTitle,
          reportDescription: description,
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .then(() => {
        store.commit("grantItems/disableShareGrantsPage", false);
      });
  }

  async shareSchemesMultiple(
    recipients,
    message,
    description,
    reportTitle,
    ids,
    reportType,
    locale
  ) {
    if (env.value === 0) {
      if (message == null || message == "") {
        store.commit(
          "grantItems/updateModalError",
          "The message cannot be empty!"
        ),
          store.commit("grantItems/enableModalError");
      }
    }

    return await axios
      .post(
        API_URL + "/mailing/shareSchemesMultiple",
        {
          recipients: recipients,
          message: message,
          schemeIds: ids,
          reportTitle: reportTitle,
          reportDescription: description,
          reportType: reportType,
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .then(() => {
        store.commit("grantItems/disableShareGrantsPage", false);
      })
      .catch((error) => {
        store.commit("grantItems/disableShareGrantsPage");
        store.commit("grantItems/updateModalError", error.response.data),
          store.commit("grantItems/enableModalError");
      });
  }

  async getReportTypes(isVind, custid) {
    return await axios
      .get(API_URL + "/mailing/getAllReportTypes")
      .then((response) => {
        store.commit("mailing/updateReportTypesLists", {
          types: response.data,
          isVind: isVind,
          customerId: custid,
        });
      });
  }
}

export default new MailingService();
